import React from 'react'
import { Collapse, Row, Col, Card, Avatar, Button, Tag } from 'antd'
import Moment from 'react-moment'
import { DownOutlined, EnvironmentOutlined } from '@ant-design/icons'

import './styles.less'

const { Panel } = Collapse

const formatDate = (copy, date) => {
  const msToMinutes = Math.floor((new Date() - new Date(date)) / 1000 / 60)
  if (msToMinutes > 60) {
    const hours = Math.floor(msToMinutes / 60)
    if (hours > 24) {
      const days = Math.floor(hours / 24)
      return `${days}
      ${days > 1 ? copy('jobs.tasks.assign.days') : copy('jobs.tasks.assign.day')}`
    }
    return `${hours}
    ${hours > 1 ? copy('jobs.tasks.assign.hours') : copy('jobs.tasks.assign.hour')}`
  } else {
    return `${msToMinutes}
    ${msToMinutes > 1 ? copy('jobs.tasks.assign.minutes') : copy('jobs.tasks.assign.minute')}`
  }
}

const ResourceCard = ({
  showTagWithoutAssignedQuota,
  copy,
  timeZone,
  resource = { vehicle: {} },
  potentialPayment = null,
  actions = null,
  onClickResource = null
}) => {
  const {
    id,
    phone,
    createdAt,
    photoUrl,
    firstName,
    lastName,
    distance,
    assignedTasks,
    from,
    to,
    lastUpdatePosition,
    vehicle: { label, capacity },
    isTakeQuotasEnabled,
    withQuota,
    wantsToReceiveTasks
  } = resource

  const lastConnection = () => {
    if (!lastUpdatePosition) {
      return copy('jobs.tasks.assign.location')
    }
    return formatDate(copy, lastUpdatePosition)
  }

  const showQuotaTag = () => {
    const { color, text } = withQuota
      ? { color: 'default', text: copy('jobs.tasks.resource.quota-assigned') }
      : { color: 'red', text: copy('jobs.tasks.resource.no-quota-assigned') }

    return <Tag color={color}>{text}</Tag>
  }

  const details = () => (
    <Collapse className='resources-details' ghost>
      <Panel
        header={
          <div className='resources-details-action'>
            {copy('routes.steps.selectResources.details')}
            <DownOutlined className='resources-details-icon' />
          </div>
        }
        showArrow={false}
        key={`resource-panel-${id}`}
      >
        <div className='resource-details'>
          <div className='resource-general-info'>
            <dl>
              <dt>{copy('routes.steps.selectResources.phone')}: </dt>
              <dd>{phone}</dd>
            </dl>
            {createdAt && (
              <dl>
                <dt>{copy('routes.steps.selectResources.createdAt')}: </dt>
                <dd>
                  <Moment local format='l' tz={timeZone}>
                    {createdAt}
                  </Moment>
                </dd>
              </dl>
            )}
          </div>
        </div>
      </Panel>
    </Collapse>
  )

  return (
    <div className='resource-content'>
      <Card actions={[details()]}>
        <Row className='resource-header' justify='space-between' gutter={[0, 8]}>
          <Col span={18}>
            <Row gutter={[16, 0]}>
              <Col className='resource-image' span={4}>
                {potentialPayment}
                <Avatar size='large' src={photoUrl} />
              </Col>
              <Col className='resource-main-info' span={18}>
                {onClickResource ? (
                  <Button className='resource-profile-btn' type='link' onClick={() => onClickResource(id)}>
                    {`${firstName} ${lastName}`}
                  </Button>
                ) : (
                  <h3 className='resource-name'>{`${firstName} ${lastName}`}</h3>
                )}
                <span className='resource-last-location'>
                  {lastUpdatePosition
                    ? copy('routes.steps.selectResources.lastUpdate', { time: lastConnection() })
                    : copy('routes.steps.selectResources.nullLastUpdate')}
                </span>
              </Col>
            </Row>
          </Col>
          <Col className='resource-distance' span={6}>
            {distance && (
              <span>
                <EnvironmentOutlined /> {(distance / 1000).toFixed(2)} km
              </span>
            )}
          </Col>
        </Row>
        <div className='resource-info'>
          <div className='resource-general-info'>
            <dl>
              <dt>{copy('routes.steps.selectResources.vehicle')}: </dt>
              <dd>{label}</dd>
            </dl>
            {capacity && (
              <dl>
                <dt>{copy('routes.steps.selectResources.capacity')}: </dt>
                <dd>
                  {capacity} {copy('routes.steps.routes.results.table.items')}
                </dd>
              </dl>
            )}
            <dl>
              <dt>{copy('routes.steps.selectResources.assignedJobs')}: </dt>
              <dd>{assignedTasks}</dd>
            </dl>
            <dl>
              <dt>{copy('availability')}: </dt>
              <dd>{wantsToReceiveTasks ? copy('active') : copy('inactive')}</dd>
            </dl>
            {from && to && (
              <dl>
                <dt>{copy('routes.steps.selectResources.quota')}: </dt>
                <dd>
                  <Moment local format='HH:mm' tz={timeZone}>
                    {from}
                  </Moment>
                  {' - '}
                  <Moment local format='HH:mm' tz={timeZone}>
                    {to}
                  </Moment>
                </dd>
              </dl>
            )}
          </div>
          <div className='assigned-quota'>
            {isTakeQuotasEnabled && showTagWithoutAssignedQuota && showQuotaTag()}
            {actions && <div className='resource-actions'>{actions}</div>}
          </div>
        </div>
      </Card>
    </div>
  )
}

export default ResourceCard
